import styled from 'styled-components';

export const ColumnGuide = styled.div`
  height: 100vh;
  background: rgba(0, 212, 255, 1);
`;

export const Overlay = styled.div`
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5000;
  min-width: 320px;
  pointer-events: none;
  opacity: 0.2;
`;

export const ScreenClass = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  text-transform: uppercase;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 150px;
  font-weight: bold;
  color: #fff;
  opacity: 1;
  mix-blend-mode: overlay;
`;
